import { keyframes } from '@emotion/react'
import { AnimationProps } from '../types'

const slideRight = (width: number): ReturnType<typeof keyframes> => keyframes`
from {
  transform: translate(0, 0);
}

to {
  transform: translate(${width}px, 0);
}
`

const slideLeft = (width: number): ReturnType<typeof keyframes> => keyframes`
from {
  transform: translate(0, 0);
}

to {
  transform: translate(-${width}px, 0);
}
`

const arrowsAnimation: AnimationProps = {
  animate: { opacity: 1 },
  initial: { opacity: 0 },
  transition: {
    default: {
      duration: 0.3,
      ease: [0, 0.7, 0.2, 1],
    },
    scale: {
      type: 'spring',
      damping: 10,
      stiffness: 100,
      restDelta: 0.001,
    },
  },
}

const animations = {
  arrowsAnimation,
  slideLeft,
  slideRight,
}

export { animations }
